import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GraduationCap, Layers } from "lucide-react";

type TabType = "Programs" | "Variants";

export const academyTabs = [
  {
    label: "Programs",
    Icon: GraduationCap,
    count: 0,
    value: "Programs" as TabType,
  },
  {
    label: "Variants",
    Icon: Layers,
    count: 0,
    value: "Variants" as TabType,
  },
];

export interface AcademyDealPreviewEntry {
  variantId: number;
  variantName: string;
  courseFees: number;
  discountAllowed: number;
  totalFees: number;
  advancePaid: number;
  remainingToPay: number;
}

export interface AcademyDealPreviewDeal {
  name: string;
  variantId: number;
  variantName: string;
  courseFees: number;
  discount: number;
}

export interface AcademyDealPreviewData {
  programName: string;
  programCode: string;
  entries: AcademyDealPreviewEntry[];
  deals: AcademyDealPreviewDeal[];
  grossTotal: number;
  discountType: "amount" | "percentage";
  discountValue: number;
  discountAmount: number;
  netAmount: number;
  advance: number;
  advanceMethod: string;
  advanceBankName: string;
  advanceReceiptDocId?: number | null;
  pending: number;
}

const initialState = {
  isAddProgram: false,
  /** program id whose edit drawer is open (null = closed) */
  editProgramId: null as number | string | null,
  isAddVariant: false,
  academyActiveTab: "Programs" as TabType,
  isProgramDetails: false,
  programDetailId: null as number | string | null,
  variantDetailId: null as number | string | null,
  startDeal: false,
  showDealPreview: false,
  dealPreviewData: null as AcademyDealPreviewData | null,
  pendingDealCount: 0,
  triggerReview: false,
};

const academyFunctionalSlice = createSlice({
  name: "academyFunctional",
  initialState,
  reducers: {
    setIsAddProgram: (state, action: PayloadAction<boolean>) => {
      state.isAddProgram = action.payload;
    },
    setEditProgramId: (
      state,
      action: PayloadAction<number | string | null>
    ) => {
      state.editProgramId = action.payload;
    },
    setIsAddVariant: (state, action: PayloadAction<boolean>) => {
      state.isAddVariant = action.payload;
    },
    setAcademyActiveTab: (state, action: PayloadAction<TabType>) => {
      state.academyActiveTab = action.payload;
    },
    setIsProgramDetails: (state, action: PayloadAction<boolean>) => {
      state.isProgramDetails = action.payload;
    },
    setProgramDetailId: (
      state,
      action: PayloadAction<number | string | null>
    ) => {
      state.programDetailId = action.payload;
    },
    setVariantDetailId: (
      state,
      action: PayloadAction<number | string | null>
    ) => {
      state.variantDetailId = action.payload;
    },
    setStartDeal: (state, action: PayloadAction<boolean>) => {
      state.startDeal = action.payload;
    },
    setShowDealPreview: (state, action: PayloadAction<boolean>) => {
      state.showDealPreview = action.payload;
    },
    setDealPreviewData: (
      state,
      action: PayloadAction<AcademyDealPreviewData | null>
    ) => {
      state.dealPreviewData = action.payload;
    },
    clearDealPreview: (state) => {
      state.showDealPreview = false;
      state.dealPreviewData = null;
      state.pendingDealCount = 0;
      state.triggerReview = false;
    },
    setPendingDealCount: (state, action: PayloadAction<number>) => {
      state.pendingDealCount = action.payload;
    },
    setTriggerReview: (state, action: PayloadAction<boolean>) => {
      state.triggerReview = action.payload;
    },
  },
});

export const {
  setIsAddProgram,
  setEditProgramId,
  setIsAddVariant,
  setAcademyActiveTab,
  setIsProgramDetails,
  setProgramDetailId,
  setVariantDetailId,
  setStartDeal,
  setShowDealPreview,
  setDealPreviewData,
  clearDealPreview,
  setPendingDealCount,
  setTriggerReview,
} = academyFunctionalSlice.actions;
export default academyFunctionalSlice.reducer;
